import React from "react";
import { displayCountry, displayCustomer, displayOwnerSe, displayPageRanges, displayRfpVersion, formatWhen } from "./rfpUtils";

function StatusBadge({ status, phase }) {
  const map = {
    completed: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950/50 dark:text-emerald-200",
    processing: "bg-amber-100 text-amber-900 dark:bg-amber-950/50 dark:text-amber-200",
    failed: "bg-red-100 text-red-800 dark:bg-red-950/50 dark:text-red-200",
    queued: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
    reviewed: "bg-sky-100 text-sky-800 dark:bg-sky-950/50 dark:text-sky-200",
  };
  const cls = map[status] || map[phase] || map.queued;
  return (
    <span className={`inline-flex shrink-0 rounded-full px-2 py-0.5 text-xs font-medium ${cls}`}>
      {status}
    </span>
  );
}

export default function RfpJobCard({ job, active, onOpen }) {
  const customer = displayCustomer(job);
  const owner = displayOwnerSe(job);
  const country = displayCountry(job);
  const version = displayRfpVersion(job);
  const filename = job.filename || "—";
  const pages = displayPageRanges(job);
  const reqCount = job.requirement_count ?? "—";
  const rowCount = job.row_count ?? "—";

  return (
    <button
      type="button"
      onClick={() => onOpen(job.job_id)}
      className={`group w-full rounded-xl border p-3.5 text-left transition hover:shadow-md ${
        active
          ? "border-emerald-500 bg-emerald-50/60 ring-1 ring-emerald-500/40 dark:border-emerald-600 dark:bg-emerald-950/25"
          : "border-slate-200 bg-white hover:border-emerald-300 dark:border-slate-700 dark:bg-slate-900/80 dark:hover:border-emerald-700"
      }`}
    >
      <div className="mb-1 flex items-start justify-between gap-2">
        <h3 className="truncate text-base font-semibold text-slate-900 group-hover:text-emerald-800 dark:text-slate-100 dark:group-hover:text-emerald-200">
          {customer}
        </h3>
        <StatusBadge status={job.status} phase={job.phase} />
      </div>
      <p className="mb-2 text-sm text-slate-600 dark:text-slate-300">
        Owner SE: {owner} · {country}
        {version ? ` · ${version}` : ""}
      </p>
      <p className="truncate text-xs text-slate-500 dark:text-slate-400">File: {filename}</p>
      {pages ? (
        <p className="mt-1 truncate text-xs text-slate-500 dark:text-slate-400">Pages: {pages}</p>
      ) : null}
      <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
        {reqCount} requirements · {rowCount} rows · {job.status || "unknown"}
      </p>
      {job.updated_at && (
        <p className="mt-1.5 text-xs text-slate-400 dark:text-slate-500">Updated: {formatWhen(job.updated_at)}</p>
      )}
    </button>
  );
}

export { StatusBadge };
